/**
 * @param {*} reason - The unhandled rejection reason.
 * @returns {boolean}
 */
export default function isAccessDeniedError(reason) {
    const status = reason?.response?.status;

    return (status === 403 || status === 412) && reason?.config?.errorHandle !== false;
}
